import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Field } from "@/components/kit";
import { Stepper } from "@/components/Stepper";
import { TankPicker } from "@/components/drop/TankPicker";
import { SiteSwitcher } from "@/components/drop/SiteSwitcher";
import { useSession } from "@/context/SessionContext";
import { useT } from "@/lib/i18n";
import { formatGal, formatToEighths, tankKey, TANK_PRESETS } from "@/lib/tank";
import { StickPhoto } from "@/components/StickPhoto";
import { TrustPanel } from "@/components/TrustPanel";
import { ChartSource } from "@/components/ChartSource";

export function StickCheck() {
  const { session: s, result: r, patch } = useSession();
  const t = useT();
  const nav = useNavigate();
  const [custom, setCustom] = useState(() => !TANK_PRESETS.some((x) => tankKey(x) === tankKey(s)));
  const pct = r.startPct;
  const room = (cap) => Math.max(0, cap - r.startGallons);

  return (
    <div className="stick-check" data-testid="stick-check">
      <SiteSwitcher s={s} patch={patch} onTank={(p) => setCustom(!TANK_PRESETS.some((x) => tankKey(x) === tankKey(p)))} />
      <TankPicker s={s} patch={patch} custom={custom} setCustom={setCustom} compact />
      <Field label={t("Your stick reading")}>
        <Stepper blank testID="stick-only-inches" unit="in" decimal step={0.125} max={s.diameter} value={s.startInches} onValue={(v) => patch({ startInches: v })} />
        <StickPhoto testid="stick-only-inches" max={s.diameter} onValue={(v) => patch({ startInches: v })} />
      </Field>
      {!(s.startInches > 0) ? (
        <div className="stick-result empty-result" data-testid="stick-result-empty">{t("Type your stick reading to see the gallons in the tank.")}</div>
      ) : (
      <div className="stick-result" data-testid="stick-result">
        <div className="label">{t("In the tank now")}</div>
        <div className="stick-big mono" data-testid="stick-gallons">{formatGal(r.startGallons)}<small> gal</small></div>
        <div className="card-sub mono">{formatToEighths(s.startInches)} · {pct.toFixed(1)}% {t("full")}</div>
        <div className="stick-rooms">
          <div><span className="label">{t("Room to 90%")}</span><span className="mono stick-room" data-testid="stick-room90">{formatGal(room(r.cap90))} gal</span></div>
        </div>
      </div>
      )}
      <ChartSource s={s} r={r} testid="stick-chart-source" />
      <TrustPanel s={s} r={r} />
      <button type="button" className="primary-btn" data-testid="stick-plan-drop" onClick={() => nav("/drop")}>
        {t("Plan the drop")}<ArrowRight size={16} />
      </button>
    </div>
  );
}
